<section>
  <div class="container">
    <!-- <div class="row">
      <div class="col-md-12">
        <h4>{{'legal-page-title' | translate}}</h4>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-12 mt-2 pt-2">
        <div [innerHTML]="'legal-page-par-1' | translate | safeHtml"></div>
        <div [innerHTML]="'legal-page-par-2' | translate | safeHtml"></div>
        <div [innerHTML]="'legal-page-par-3' | translate | safeHtml"></div>
        <div [innerHTML]="'legal-page-par-4' | translate | safeHtml"></div>

        <div [innerHTML]="'legal-page-par-5-title' | translate | safeHtml"></div>
        <p>
          <span [innerHTML]="'legal-page-par-5-pre' | translate"></span>
          <a href="javascript:void(0)" (click)="openPrivacy()">{{'legal-page-par-5-link' | translate}}</a>&nbsp;
          <span [innerHTML]="'legal-page-par-5-post' | translate"></span>
        </p>
      </div>
    </div>
  </div>
</section>
